module.exports = __webpack_public_path__ + "img/ledger.6c03007e.png";